// Every user-facing string, by key. Do not write strings in screens; add them here.
// Transcribed mechanically from build/ui-copy.md, build/growth-copy.md and build/trust-copy.md
// (option A where a file offers a choice; {APP} replaced with Magellan).

export const COPY = {
  // ui-copy.md
  "who.title": "Who are these plans for?",
  "who.solo": "Just me",
  "who.couple": "Me and my partner",
  "deck.title": "What's your kind of LA?",
  "deck.hint": "Swipe or tap to rate each idea.",
  "deck.love": "Love",
  "deck.like": "Like",
  "deck.meh": "Meh",
  "deck.no": "No",
  "deck.progress": "{N} of {TOTAL}",
  "deck.undo": "Undo",
  "budget.title": "What's your budget per person?",
  "budget.opt1": "Free",
  "budget.opt2": "Up to $30",
  "budget.opt3": "Up to $75",
  "budget.opt4": "No limit",
  "drive.title": "How long would you drive?",
  "drive.opt1": "15 minutes",
  "drive.opt2": "30 minutes",
  "drive.opt3": "45 minutes",
  "drive.opt4": "60+ minutes",
  "area.title": "Where do you usually start from?",
  "area.placeholder": "Neighborhood or ZIP",
  "nos.title": "Anything you'd rather skip?",
  "nos.sub": "Tap any that apply.",
  "nos.chips.1": "Late nights",
  "nos.chips.2": "Big crowds",
  "nos.chips.3": "Drinking-centered",
  "nos.chips.4": "Long hikes",
  "nos.chips.5": "Loud music",
  "nos.chips.6": "Early mornings",
  "saturday.title": "What's your idea of a perfect Saturday?",
  "saturday.placeholder": "Coffee, a little wandering, then live music somewhere I can sit down.",
  "saturday.skip": "Skip for now",
  "intake.finish": "See my picks",
  "loading.lines.1": "Getting a feel for your kind of LA.",
  "loading.lines.2": "Looking through this week's options.",
  "loading.lines.3": "Putting your five picks together.",
  "picks.header.solo": "Five LA picks with your taste in mind.",
  "picks.sub": "Your week of {DATE}",
  "pick.why.label": "Why it fits",
  "pick.cal.google": "Google Calendar",
  "pick.cal.ics": "Download calendar file",
  "pick.share": "Share",
  "pick.pass": "Not for me",
  "pick.added": "Finish saving in your calendar.",
  "aha.toast": "From a good idea to a plan on your calendar.",
  "picks.partner.waiting": "Invite {PARTNER} to share their taste. Once they finish, your picks will fit you both.",
  "picks.empty": "No picks fit all your filters this week. Try a wider drive range or a different budget.",
  "picks.empty.button": "Adjust filters",
  "picks.error": "Your picks didn't load. Give it another try.",
  "retry": "Try again",
  "feedback.title": "How was {PICK}?",
  "feedback.loved": "Loved it",
  "feedback.fine": "Fine",
  "feedback.skipped": "Skipped it",
  "feedback.heard.title": "Had you heard of it before?",
  "feedback.heard.yes": "Yes",
  "feedback.heard.no": "No",
  "feedback.tip.placeholder": "Any tips for someone going? (Optional)",
  "feedback.thanks": "Thanks for sharing how it went.",
  "contribute.title": "Found something in LA?",
  "contribute.sub": "Paste an LA event link or details for the shared pool. Stay anonymous or choose to get credit.",
  "contribute.placeholder": "Event link or details, including date and place",
  "contribute.button": "Add event",
  "contribute.working": "Reading the event details.",
  "contribute.success": "Added to the shared pool. Want it on your calendar too?",
  "contribute.fail": "Couldn't read the event details. Add the date and place so we can try again.",
  "contribute.notla": "This looks outside LA. The shared pool is for LA events.",
  "contribute.past": "This date has passed. Try an upcoming event.",
  "contribute.credit": "Show me as the finder",
  "error.generic": "Something didn't work. Please try again.",
  "error.offline": "You're offline. Reconnect to keep going.",
  "nav.picks": "My picks",
  "nav.add": "Add event",
  "nav.invite": "Invite",
  "reset.link": "Retake intake",
  "area.select.placeholder": "Choose your area",
  "deck.finish_early": "I've seen enough",
  "when.title": "When would you go?",
  "when.morning": "Morning 10am",
  "when.afternoon": "Afternoon 2pm",
  "when.evening": "Evening 7pm",
  "badge.onenight": "One night only",
  "pick.details": "Event details",
  "pick.pass.toast": "Removed from your picks.",
  "share.copied": "Link copied",
  "why.fallback": "{CARD} felt like your kind of plan.",
  "picks.slow": "Still looking through this week's options.",
  "contribute.duplicate": "This one's already in the shared pool.",
  "contribute.name.label": "Name to show",
  "settings.title": "Edit your filters",
  "settings.save": "Save",
  // growth-copy.md
  "invite.share_text": "Want to find our kind of LA plans? Take about 2 minutes on Magellan so this week's picks fit both of us: {LINK}",
  "invite.landing.headline": "Your taste belongs in these plans",
  "invite.landing.sub": "{NAME} invited you. Take about 2 minutes to get this week's LA picks matched to both of you.",
  "invite.landing.button": "Add my taste",
  "invite.prompt.line": "Bring your partner's taste into the mix. Get picks that fit you both.",
  "invite.prompt.button": "Invite my partner",
  "share.pick.text": "Want to go to {PICK} on {DATE} with me? Found it on Magellan. {LINK}",
  "share.card.footer": "A little LA discovery, via Magellan",
  "couple.match.header": "Two tastes. Five LA picks for this week.",
  "finder.card.line": "Get a founding finder mark, choose credit on events you add, and share your finds with people whose taste fits.",
  "finder.credit": "found by {FINDER}",
  "reminder.offer.line": "Add a weekly Thursday 9am calendar reminder for fresh LA picks.",
  "reminder.offer.button": "Add weekly reminder",
  "reminder.event.title": "Your week in LA",
  "reminder.event.description": "Five fresh LA picks for your taste. See what catches your eye: {LINK}",
  "calendar.event.feedback_line": "After you go, tell us how it was in one tap: {FEEDBACK_LINK}",
  "share.landing.headline": "Your own little list of LA",
  "share.landing.sub": "Tell us what you like in about 2 minutes. Get your own weekly LA picks.",
  "share.landing.button": "Get my picks",
  "contribute.success.line": "Got your link. A person will check it before it goes any further.",
  "contribute.success.button": "Add to my calendar",
  "picks.footer.refresh": "That's this week's list. New picks arrive every Thursday.",
  // trust-copy.md
  'consent.line': "By tapping the button below, you confirm you're 18 or older, agree to the [Terms](/terms), and acknowledge the [Privacy](/privacy) page.",
  'start.button': "I'm 18 or older — start",

  // NEW COPY: written by Claude (Opus) on 10/01/26 while Astra was out. Not yet gated; listed in the build report.
  'intake.next': 'Next',
  'nav.back': 'Back',
  'nav.close': 'Close',
  'nav.settings': 'Settings',
  'loading': 'Loading',
  'badge.radar': 'Under the radar',
  'picks.refresh': 'Refresh my picks',
  'aha.share': 'Share a find',
  'aha.keep': 'Keep going',
  'feedback.submit': 'Send',
  'invite.title': 'Invite your partner',
  'invite.copy': 'Copy link',
  'invite.name.fallback': 'Your partner',
  'partner.fallback': 'your partner',
  'contribute.accepted': 'Added to the shared pool. Thanks for the find.',
  'settings.leave': 'Unlink from your partner',
  'settings.delete': 'Delete my data',
  'settings.delete.confirm': "This erases your profile, answers, passes, and ratings right away. It can't be undone.",
  'settings.delete.cancel': 'Keep my data',
  'legal.privacy': 'Privacy',
  'legal.terms': 'Terms',
  'week.title': "What sounds good this week?",
  'week.date': 'Date night',
  'week.solo': "Time to myself",
  'week.friends': "Time with friends",
  'week.new': 'Something new',
  'week.weekend': 'This weekend',
  'week.weeknight': 'Weeknights',
  'week.any': "Any day this week",
  'voice.title': "Tell us what you're into",
  'voice.hint.1': 'what you love doing',
  'voice.hint.2': "what you'd skip",
  'voice.hint.3': "how far you'd drive",
  'voice.start': 'Tap to talk',
  'voice.stop': 'Tap to stop',
  'voice.type': 'Type instead',
  'voice.more': "Tell us a little more.",
  'taste.talk': 'Talk',
  'taste.tap': 'Tap',
  'saturday.mic.start': 'Talk instead of typing',
  'saturday.mic.stop': 'Stop listening',
  'saturday.listening': 'Listening',
  'tune.learning': "What we're learning",
  'tune.learning.empty': "Your taste takes shape here.",
  'tune.not': "less: {X}",
  'taste.min': 'Pick at least 3',
  'voice.hint.1.insert': 'I love ',
  'voice.hint.2.insert': "I'd skip ",
  'voice.hint.3.insert': "I'd drive about ",
  'invite.title.solo': 'Invite someone to plan with',
  'invite.line.solo': 'Send them the link. Once they add their taste, your picks will fit you both.',
  'portrait.title': "Here's what we think you're like",
  'portrait.loading': 'Putting it together',
  'portrait.yes': 'Yes',
  'portrait.no': 'Not quite',
  'portrait.why': 'Why?',
  'picks.header.solo.some': 'LA picks with your taste in mind.',
  'couple.match.header.some': 'Two tastes. LA picks for this week.',
  'pick.time.hint': 'Pick a time that works in your calendar',
  'invite.copied': 'Copied',
} as const

// Round 4 strings (build/CLIENT-FIXES-r4.md). Temporary values: Claude swaps in Astra's drafted strings after the gate.
export const R4 = {
  'cal.apple': "Apple Calendar",
  'cal.google': "Google Calendar",
  'cal.other': "Other calendars",
  'cal.after_google': "Tap Save in the Google Calendar tab to finish.",
  'cal.after_apple': "Tap Add in your calendar to finish.",
  'cal.added_badge': "Sent to calendar",
  'why_not.prompt': "What didn't fit? (optional)",
  'why_not.too_far': "Too far",
  'why_not.too_late': "Too late",
  'why_not.too_pricey': "Too pricey",
  'why_not.wrong_day': "Wrong day",
  'why_not.wrong_vibe': "Wrong vibe",
  'why_not.not_my_thing': "Not my thing",
  'why_not.been_there': "Been there",
  'why_not.thanks': "Thanks, that helps",
  'picks.refresh': "Replace these picks",
  'picks.replaced': "Here's another pick in its place.",
  'week.pick_days': "Choose my days",
  'week.days_help': "Tap any days that work for you this week.",
  'price.unknown': "Price not listed",
  // Extra key, not in the r4 list: the price rule needs a word for is_free items.
  'price.free': 'Free',
  'loved_badge': "You loved this",
  'picks.title': 'Your picks this week',
  // {RANGE} = the week, e.g. "Thu Oct 1 – Wed Oct 7"
  'picks.subtitle': '{RANGE}',
} as const

// Round 5 strings (build/CLIENT-NEXT.md: desktop, map, nights, couple votes). Short plain temporary values.
// R5 strings: drafted by Astra (build/astra/copy-r5.txt), gated by Claude 10/02/26.
export const R5 = {
  'brand': "Magellan",
  'view.list': "List",
  'view.map': "Map",
  'view.label': "Show picks as",
  'map.you': "Your starting area",
  'map.no_location': "No map location",
  'map.fit': "Show all picks",
  'map.unavailable': "The map couldn't load. You can still use the list.",
  'map.label': "Map of your picks",
  'map.attribution': '© OpenStreetMap contributors', // required attribution, fixed wording
  'map.pin': "{N}. {TITLE}",
  'night.button': "Plan a night",
  'night.title': "Your night",
  'night.loading': "Planning your night",
  'night.error': "We couldn't plan this night. Try again in a moment.",
  'night.not_possible': "We don't have stops to pair with this pick yet.",
  'night.before': "Before",
  'night.after': "After",
  'night.anchor': "Your pick",
  'night.swap': "Swap",
  'night.calmer': "Quieter",
  'night.closer': "Closer",
  'night.cheaper': "Lower cost",
  'night.remove': "Remove",
  'night.undo': "Undo",
  'night.add_before': "Add before",
  'night.add_after': "Add after",
  'night.options': "Other stops",
  'night.no_options': "No other stops fit here right now.",
  'night.walk': "{MIN} min walk",
  'night.drive': "{MIN} min drive",
  'night.hours': "Hours: {HOURS}",
  'night.check_hours': "Check opening hours",
  'night.source': "View source",
  'night.label.fit': "Fits your taste",
  'night.label.find': "Lesser known",
  'night.label.wildcard': "Something different",
  'night.surprise': "Hide from partner",
  'night.cal_apple': "Apple Calendar",
  'night.cal_google': "Google Calendar",
  'night.cal_other': "Other calendars",
  'night.saving': "Saving your night",
  'night.saved': "Night saved. Finish adding it in your calendar.",
  'night.save_error': "Your night couldn't be saved. Try again.",
  'night.conflict': "Your partner updated this night. You're seeing the latest version.",
  'night.cal_title': "Night out: {TITLE}",
  'night.cal_stops': "Stops",
  'night.your_nights': "Saved nights",
  'night.stops_count': "{N} stops",
  'night.back_to_picks': "Back to picks",
  'vote.yes': "Yes",
  'vote.no': "Not this time",
  'vote.both': "You both said yes",
  'vote.partner_yes': "Your partner said yes",
  'vote.partner_no': "Your partner said not this time",
  'vote.partner_none': "Your partner hasn't voted yet",
  'vote.label': "Your vote",
  'vote.error': "Your vote couldn't be saved. Try again.",
  'picks.context.start': "Starting from {AREA}",
  'theme.title': "Appearance",
  'theme.system': "Follow device",
  'theme.light': "Light",
  'theme.dark': "Dark",
} as const

// Round 6 strings: Explore, more like this, shared nights, Ask. Short plain temporary values for Astra to redraft.
// ASTRA-PENDING
export const R6 = {
  'nav.picks': "Picks",
  'nav.explore': "Explore",
  'explore.title': "Explore",
  'explore.subtitle': "Everything this week, best matches first",
  'explore.entry': "Explore this week",
  'explore.count': "{N} things",
  'explore.count_one': "1 thing",
  'explore.error': "We couldn't load this week's picks. Try again.",
  'explore.filters': "Filters",
  'explore.categories': "Categories",
  'explore.clear': "Clear filters",
  'explore.empty': "No matches with these filters.",
  'explore.empty_undo': "Remove {CHIP}",
  'explore.more': "Show more",
  'explore.distance': "{MI} mi away",
  'explore.map_label': "Map of these picks",
  'chip.tonight': "Tonight",
  'chip.weekend': "This weekend",
  'chip.free': "Free",
  'chip.outdoors': "Outdoors",
  'chip.active': "Active",
  'chip.late': "Late night",
  'chip.near': "Near me",
  'chip.radar': "Under the radar",
  'chip.food': "Food",
  'cat.music': "Music",
  'cat.comedy': "Comedy",
  'cat.art': "Art",
  'cat.film': "Film",
  'cat.outdoors': "Nature",
  'cat.class': "Classes",
  'cat.community': "Community",
  'cat.theater': "Theater",
  'cat.market': "Markets",
  'cat.fitness': "Fitness",
  'cat.other': "Other",
  'more.button': "More like this",
  'more.title': "More like this",
  'more.empty': "No similar picks yet.",
  'more.add': "Add to calendar",
  'more.added': "Added to calendar",
  'share.button': "Share this night",
  'share.loading': "Creating your link",
  'share.copied': "Link copied",
  'share.manual': "Copy this link",
  'share.error': "We couldn't create a link. Try again.",
  'share.title': "A night out in LA",
  'shared.title': "A night out",
  'shared.anchor': "Main event",
  'shared.loading': "Loading the plan",
  'shared.gone': "This shared plan is no longer available.",
  'shared.error': "We couldn't load the plan. Try again.",
  'shared.cta': "Find your picks",
  'shared.cta_line': "Find things to do in LA that fit your taste, including small, one-off events.",
  'shared.map_label': "Map of the plan",
  'ask.label': "What sounds good?",
  'ask.placeholder': "Try \"free and outdoors Saturday morning\"",
  'ask.submit': "Ask",
  'ask.try': "Try",
  'ask.example.1': "Live jazz tonight",
  'ask.example.2': "Free and outdoors Saturday morning",
  'ask.example.3': "Something hands-on this weekend",
  'ask.loading': "Looking for {Q}",
  'ask.clear': "Clear search",
  'ask.empty': "No matches this week. Try a different day or fewer details.",
  'ask.error': "We couldn't finish your search. Try again.",
} as const

export type R6Key = keyof typeof R6

/** Look up a round 6 string and fill its {PLACEHOLDERS}. */
export function r6(key: R6Key, vars?: Record<string, string | number>): string {
  let s: string = R6[key]
  if (vars) for (const [k, v] of Object.entries(vars)) s = s.replaceAll(`{${k}}`, String(v))
  return s
}

export type R5Key = keyof typeof R5

/** Look up a round 5 string and fill its {PLACEHOLDERS}. */
export function r5(key: R5Key, vars?: Record<string, string | number>): string {
  let s: string = R5[key]
  if (vars) for (const [k, v] of Object.entries(vars)) s = s.replaceAll(`{${k}}`, String(v))
  return s
}

export type R4Key = keyof typeof R4

/** Look up a round 4 string and fill its {PLACEHOLDERS}. */
export function r4(key: R4Key, vars?: Record<string, string | number>): string {
  let s: string = R4[key]
  if (vars) for (const [k, v] of Object.entries(vars)) s = s.replaceAll(`{${k}}`, String(v))
  return s
}

export type CopyKey = keyof typeof COPY

/** Look up a string and fill its {PLACEHOLDERS}. */
export function t(key: CopyKey, vars?: Record<string, string | number>): string {
  let s: string = COPY[key]
  if (vars) for (const [k, v] of Object.entries(vars)) s = s.replaceAll(`{${k}}`, String(v))
  return s
}

// Privacy and Terms pages, verbatim from build/trust-copy.md (markdown subset: ### headings, - lists, [links](/path)).
// {DATE}, {OPERATOR} and {CONTACT_EMAIL} are still open: Alvin fills LEGAL_VARS before launch.
export const LEGAL_VARS: Record<string, string> = { DATE: 'October 2, 2026', OPERATOR: 'Magellan', CONTACT_EMAIL: 'alvin@risegm.com' }

export const PRIVACY_MD = "### Privacy\n\nEffective date: {DATE}\n\nMagellan is operated by {OPERATOR}. For questions, contact {CONTACT_EMAIL}.\n\n### No sign-in needed\n\nEverything in Magellan works without signing in, and it stays free. Your data is saved on our servers, and access to your anonymous profile is kept in this browser. If you clear browser data or switch devices, that access is gone.\n\nSigning in with Google is optional. It keeps your taste and plans available on every device where you sign in with the same Google account.\n\n### What we store\n\n- Your preferences from the intake conversation: who is coming, dates, where you are and want to explore, what you like, how active you want to be, budget, pace, and things to avoid. You can also share your age range, gender, or whether you're local or visiting. These are optional.\n- Your answers and choices as we learn your taste, including picks you like or pass on. If you give a reason for passing, such as too far, too late, or too pricey, we save it to improve your picks.\n- Your saved plans and itineraries, picks you add to your calendar, after-event ratings, and answers about whether you'd heard of a place.\n- Events you submit, your partner link if you connect with someone, votes on shared picks, and sharing settings for your plans.\n\nYou can skip any intake question. We keep what you tell us as preferences, but we don't keep health or medical details. Before storing anything from the conversation, we drop sentences that mention those details and keep only a practical preference, such as \"step-free\" or \"take it easy.\"\n\nWe don't ask you directly for your name, email, phone number or exact address. If you choose Google sign-in, Google gives us your email address, the name on your Google account and your Google account ID. We store these and use your email only to show your sign-in status in settings. We don't send emails or display your name. We receive nothing else from Google and never see your password. We don't access your GPS location, calendar contents, contacts, Gmail, Drive or payment information.\n\nIf you use the mic, your browser's own speech service turns your voice into text. Magellan receives only the text, never the audio. You can type or tap instead.\n\n### Who processes your data\n\n- Supabase stores your data and handles anonymous sign-in and storage of your Google sign-in.\n- If you choose Google sign-in, Google processes it under Google's own terms and privacy policy.\n- Google Gemini reads what you say or type to fill in your preferences, writes the short \"why it fits\" lines, and answers your Ask questions. It also reads public venue calendar pages to find events. Google may keep requests for a limited time to check for abuse, under its own terms.\n- Sentry handles error reports without the text you type.\n- Our web host also processes data to serve the app.\n\nWe don't sell your data, run ads, or use ad trackers. Nobody pays to be recommended.\n\nButtons for TikTok, Instagram, Reddit, YouTube, and Google Maps open searches on those services. We put only the place's name and location in the search link, with no profile or preference information. Once you open a link, that service's privacy policy applies.\n\nPlaces and opening hours come from OpenStreetMap contributors under the Open Database License (ODbL). Map tiles come from OpenFreeMap. Where shown, place information also comes from Overture Maps Foundation and Foursquare OS Places. Event details come from venues' own pages, linked on each item.\n\n### Partners and calendars\n\nA linked partner can see shared plans, each other's \"yes\" and \"not this time\" votes on shared picks, and nights or plans that aren't marked \"keep it a surprise.\" They don't see your intake answers. Shared picks can still hint at what each of you likes. Either person can unlink in settings at any time.\n\nYou can create a link to share a plan. Anyone with that link can see the stops and times only. You can turn the link off.\n\nCalendar events we create contain only the event's public details, the source link, and a link back to Magellan.\n\n### Keeping and deleting data\n\nWe keep your saved data until you delete it. Anonymous profiles with no activity for 6 months are deleted.\n\n\"Delete my data\" in settings erases your profile and saved personal data, including preferences, plans, votes, passes, reasons and ratings, right away. If you're signed in, it also deletes your sign-in and all your personal data across every device. This can't be undone. Approved events you submitted stay listed as public events, unlinked from you. They were never linked to you publicly.\n\nSigning out only clears your data and access from this browser. Your taste and plans stay with your sign-in, and your other devices stay signed in.\n\nExport of your taste data isn't available yet.\n\n### Updates\n\nWe may update this page. When we do, we change the date at the top."

export const TERMS_MD = "### Terms\n\nEffective date: {DATE}\n\nMagellan is operated by {OPERATOR}. You must be 18 or older to use it.\n\n### What Magellan offers\n\nMagellan starts with a conversation, spoken or typed, about who is coming, your dates, where you want to go, what you like, and how active you want to be. It then shows you a menu of things to do. Add what you like to a plan, saved as a day-by-day itinerary you can put on your calendar or share by link.\n\nYou can plan one evening, a weekend, or a multi-day trip. Los Angeles is our first city. Plans for other places are saved, and we tell you when we don't cover a place yet.\n\nIt's free, with no paid features today. No one pays to be recommended.\n\n### Check before you go\n\nOther people run the places and events. We link to the source and don't sell tickets. Suggested visit times are suggestions. Hours, prices, and dates come from venues' own pages or open map data and can change. Always check the linked source before you go.\n\n\"Make a night of it\" stops drawn from open map data show only practical details, such as distance and closing time.\n\nButtons for TikTok, Instagram, Reddit, YouTube, and Google Maps take you to those services.\n\nPlaces and hours include data from OpenStreetMap contributors, licensed under the Open Database License (ODbL). Map tiles come from OpenFreeMap. Some place data comes from Overture Maps Foundation and Foursquare OS Places.\n\n### Sharing an event\n\nSubmit only public events that are open to anyone and that you're allowed to share. No private parties or home addresses.\n\nWe check each submission against its source page before others see it, and may edit or remove submissions. We don't show who submitted an event. Approved events stay listed even if you delete your data.\n\nFor takedown requests or questions, contact {CONTACT_EMAIL}.\n\n### Your profile\n\nYour profile is anonymous by default. Your data is stored on our servers, and access is kept in this browser. If you clear browser data or switch devices without signing in, we can't recover that access. Signing in with Google is optional and keeps your taste and plans available on every device where you sign in with the same Google account.\n\nAnyone with your shared plan link can see its stops and times. You can turn the link off. A linked partner can see and edit shared plans.\n\nSee [Privacy](/privacy) for what we store, how partner sharing works, and how to delete your data.\n\n### These terms\n\nCalifornia law governs these terms. We may update this page; the date at the top changes when we do."
